import { useRegisterSW } from 'virtual:pwa-register/react';
import { cn } from '@cobliteam/ui/utils';
import UpdateBanner from './UpdateBanner';

import { Analytics } from '@cobliteam/analytics';
import { DatadogTrack } from '@cobliteam/datadog-rum';

import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';

const UpdateVersion = ({ sidebarOpen }: { sidebarOpen: boolean }) => {
  const { herbieDashboardVersion } = useFeatureFlags();

  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      Analytics.track('Service Worker Register Error');
      DatadogTrack.error(error);
    },
    onRegisteredSW(swUrl, registration) {
      Analytics.track('Service Worker Register Success', { swUrl });
    },
  });

  const handleUpdate = () => {
    Analytics.track('Update Sidebar Refresh Clicked');
    // Trigger the update and reload only after successful update
    updateServiceWorker(true)
      .then(() => {
        window.location.reload();
      })
      .catch((error: unknown) => {
        if (error instanceof Error) {
          DatadogTrack.error(error);
        }
        // If update fails, still reload to get latest cached version
        window.location.reload();
      });
  };

  if (needRefresh)
    return (
      <>
        <UpdateBanner />
        <div className={cn('flex items-center', sidebarOpen ? 'flex-row' : 'flex-col flex-col-reverse')}>
          <span className={cn(sidebarOpen ? 'mr-1 size-1.5 animate-pulse rounded-full bg-warning-11' : 'h-0.5 w-full rounded-full bg-warning-11')} />
          <button type='button' onClick={handleUpdate} className='flex items-center text-xs hover:underline'>
            {sidebarOpen ? `Nova versão disponível - ${herbieDashboardVersion}` : window.__DASHBOARD_MONOREPO_VERSION__}
          </button>
        </div>
      </>
    );

  return (
    <div className={cn('flex flex-col items-center text-xs', sidebarOpen ? 'flex-row ' : 'flex-col flex-col-reverse')}>
      <span className={cn(sidebarOpen ? 'mr-1 size-1.5 rounded-full bg-success' : 'h-0.5 w-full rounded-full bg-success')} />
      {sidebarOpen ? ` Versão - ${window.__DASHBOARD_MONOREPO_VERSION__}` : window.__DASHBOARD_MONOREPO_VERSION__}
    </div>
  );
};

export default UpdateVersion;
